//
import { PropTypes } from 'prop-types';
import React, { Component } from "react";
import { injectIntl } from 'react-intl';
import LoadingSpinner from '../common/spinner/LoadingSpinner';

class Redirect extends Component {
  constructor(props) {
    super();
    this.mounted = false;
    //
    this.state = {
      loading: false
    };
  }
  componentWillMount() {
    this.mounted = true;
    this.startLoader();
    window.location.assign(this.props.to);
  }

  componentWillUnmount() {
    this.stopLoader();
    this.mounted = false;
  }

  startLoader = () => {
    if (this.mounted) {
      this.setState({
        loading: true
      });
    }
  }

  stopLoader = () => {
    if (this.mounted) {
      this.setState({
        loading: false
      });
    }
  }

  render() {
    return (<div>{this.state.loading && <LoadingSpinner />}</div>);
  }
}

Redirect.propTypes = {
  to: PropTypes.string.isRequired
};

export default injectIntl(Redirect);